import { render, staticRenderFns } from "./ModalUpdateNote.vue?vue&type=template&id=2c380823&scoped=true"
import script from "./ModalUpdateNote.vue?vue&type=script&lang=js"
export * from "./ModalUpdateNote.vue?vue&type=script&lang=js"
import style0 from "./ModalUpdateNote.vue?vue&type=style&index=0&id=2c380823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c380823",
  null
  
)

export default component.exports